<template>
<div class='logs'>
  <table class='members-table'>
    <tr>
      <th style="width: 20%">
        <!-- 添加成员下拉框 -->
        所有成员
      </th>
      <th>操作信息</th>
      <th style="width: 20%">时间</th>
    </tr>
    <tr v-if="loading">
      <td class='loading-cell' colspan="10">
        <div class='spinner-wrapper'>
          <i class='ppj-icon-spinner' />
        </div>
      </td>
    </tr>
    <tr v-for="log in logs" :key="log.id" v-else>
      <td class='profile' v-once>
        <div class='img avatar' :style="{backgroundImage: 'url('+log.actor_profile_picture+')'}"></div>
        <div class='nickname'>{{log.actor}}</div>
      </td>
      <td>{{log.description}}</td>
      <td>{{dateReadable(log.created_at)}}</td>
    </tr>
  </table>
  <el-pagination small layout="prev, pager, next" :total="totalItems" :page-count="totalPages" :current-page.sync="currentPage" :page-size="pageSize" @current-change="fetch">
  </el-pagination>
</div>
</template>

<style lang='scss' scoped>
.logs {
    padding-top: $margin-base;

    .members-table .profile {
        .nickname {
            height: 3em;
        }
    }

    .el-pagination {
        margin-top: $margin-base;
        text-align: center;
    }
}
</style>

<script>
export default {
  data() {
    return {
      logs: [],
      currentPage: 1,
      totalPages: 1,
      pageSize: 1,
      totalItems: 1,
      loading: false
    }
  },
  methods: {
    fetch() {
      let vm = this
      vm.loading = true
      vm.$store.dispatch('organization/logs', {
        orgId: vm.organization.id,
        page: vm.currentPage || 1
      }).then(res => {
        vm.logs = res.data.list
        vm.totalPages = res.data.total_pages
        vm.pageSize = res.data.page_size
        vm.totalItems = res.data.total_items
        vm.loading = false
      })
    }
  },
  mounted() {
    this.fetch()
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?b8efb974